import { Box, Heading, HStack, Text } from '@medely/ui-kit';
import React from 'react';
import { AssignmentForAssignmentDetailsGql } from '../../graphql';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';

type AssignmentCompensationPayRatesProps = {
  assignment?: FragmentType<typeof AssignmentForAssignmentDetailsGql> | null;
};

type AssignmentCompensationPayRatesItemProps = {
  title: string;
  info: string;
};

const money = (cents: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100);
const rate = (cents: number) => `${money(cents)}/hr`;
const weekPay = (cents: number) => `${money(cents)}/wk`;

const AssignmentCompensationPayRatesItem = ({
  title,
  info,
}: AssignmentCompensationPayRatesItemProps) => {
  return (
    <HStack justifyContent="space-between" pt={1}>
      <Text size="m" color="text.secondary">
        {title}
      </Text>
      <Text size="m" color="text.secondary">
        {info}
      </Text>
    </HStack>
  );
};

export const AssignmentCompensationPayRates = ({
  assignment: inputAssignment,
}: AssignmentCompensationPayRatesProps) => {
  const assignment = parseFragmentData(AssignmentForAssignmentDetailsGql, inputAssignment);

  const items = [
    ['Regular (Taxable) Hourly Rate', rate(assignment?.payout_taxable_hourly_rate_cents ?? 0)],
    [
      'Overtime Rate',
      rate(
        (assignment?.payout_taxable_hourly_rate_cents ?? 0) *
          (assignment?.payout_overtime_multiplier ?? 1),
      ),
    ],
    [
      'Holiday Rate',
      rate(
        (assignment?.payout_taxable_hourly_rate_cents ?? 0) *
          (assignment?.payout_overtime_multiplier ?? 1),
      ),
    ],
    ['On Call Rate', rate(assignment?.payout_on_call_hourly_rate_cents ?? 0)],
    [
      'Call Back Rate',
      rate(
        (assignment?.payout_taxable_hourly_rate_cents ?? 0) *
          (assignment?.payout_overtime_multiplier ?? 1),
      ),
    ],
    [
      'Per Diem stipend (full week)',
      weekPay(
        7 * (assignment?.mie_per_diem_cents ?? 0) + (assignment?.lodging_per_diem_cents ?? 0),
      ),
    ],
  ].filter(Boolean) as Array<[string, string]>;

  return (
    <Box py={2}>
      <Heading size="xs">Pay Rates</Heading>
      {items.map(([value, label]) => (
        <Box key={label}>
          <AssignmentCompensationPayRatesItem info={label} title={value} />
        </Box>
      ))}
    </Box>
  );
};
